// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3hYCI","selects":"Documents_selects__x3w48"};